module.exports = __webpack_public_path__ + "static/media/textLabel_step3.ddc7d835.png";